import types from './mutation-types';

export default {
  [types.SET_CURRENT_OPEN_MENU](state, playLoad) {
    state.currentOpenMenu = playLoad;
  },
  [types.SET_CURRENT_MENU](state, playLoad) {
    state.currentMenu = playLoad;
  },
  [types.TOGGLE_SIDE_NAV](state, playLoad) {
    state.showSideNav = playLoad;
  },
  [types.CURRENT_PROJECT_ID](state, playLoad) {
    state.currentProjectId = playLoad;
  },
  [types.USER_INFO](state, playLoad) {
    state.userInfo = playLoad;
  },
  [types.AUTH_URL_LIST](state, playLoad) {
    state.authUrlList = playLoad;
  },
  [types.LANG](state, playLoad) {
    state.lang = playLoad;
  },
  [types.DICTIONARY](state, playLoad) {
    state.dictionary = playLoad;
  },
  [types.DATA_CART_LIST_PUSH](state, playLoad) {
    state.dataCartList.push(playLoad);
  },
  [types.DATA_CART_LIST_REPLACE](state, playLoad) {
    state.dataCartList = playLoad;
  },
  [types.DATA_CART_LIST_DEL_ONE](state, playLoad) {
    state.dataCartList.splice(playLoad, 1);
  },
  [types.X_AREA](state, playLoad) {
    state.xArea = playLoad;
  },
  [types.CLOUD_VALUE](state, playLoad) {
    state.cloudValue = playLoad;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js